// Route Code Edited 09/22/26
/**
 * Route Accessibility Fix
 * 
 * Fixes tab focus leaking into the collapsed #protection-benefits accordion panel.
 * aria-hidden alone doesn't remove descendants from the tab order, so this mirrors
 * it onto the `inert` attribute, which does. Re-syncs on attach and re-wires itself
 * whenever the panel node is destroyed/recreated (widget remounts on cart drawer
 * refresh, qty update, etc.), since a stale observer would otherwise watch a
 * detached node.
 * 
 * Usage:
 *   Add this script tag at the bottom of layout/theme.liquid (before </body>):
 *   <!-- Route Code Edited 08/28/2026 -->
 *   <script src="{{ 'route-accessibility-fix.js' | asset_url }}" defer></script>
 *   <!-- End Route Code -->
 */
(function () {
  var attrObserver = null;

  function syncInert(panel) {
    panel.inert = panel.getAttribute('aria-hidden') === 'true';
  }

  function wireToPanel(panel) {
    if (attrObserver) attrObserver.disconnect();
    syncInert(panel); // initial sync — panel may already be collapsed when this attaches
    attrObserver = new MutationObserver(function () {
      syncInert(panel);
    });
    attrObserver.observe(panel, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  var existing = document.getElementById('protection-benefits');
  if (existing) wireToPanel(existing);

  // Widget teardown/remount (cart drawer refresh, qty update, etc.) replaces this node —
  // rewire whenever a fresh one shows up.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      mutations[i].addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var panel = node.id === 'protection-benefits' ? node : node.querySelector && node.querySelector('#protection-benefits');
        if (panel) wireToPanel(panel);
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
// End Route Code